import React from "react";
import Layout from "../components/layout";
import WordSearchGame from "../components/v2/WordSearchGame";
import {GetStaticProps} from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../next-i18next.config";

const PuzzleGame: React.FC = () => {
    return (
        <>
        <Layout 
            isHomePage={false}
            pageTitle="Puzzle Game"
            ogImage=""
            uri="/puzzle-game"
            metaTitle=""
            metaDesc=""
            metaRobotsNoindex="noindex"
            metaRobotsNofollow="nofollow">
            <div style={{ marginTop: "-4rem" }} >
            <WordSearchGame />
            </div>
        </Layout>
        </>
    );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {

    return {
        props: {
            pageData: "",
            pageTitle: "Observability Puzzle Game – Win a Kubernetes Certification Voucher",
            description: "Solve our word search puzzle with observability concepts like metrics, tracing, and alerts for a chance to win a Kubernetes certification voucher.",
            ogImage: "",
            uri: "/puzzle-game/",
            metaTitle: "Observability Puzzle Game – Win a Kubernetes Certification Voucher",
            metaDesc: "Solve our word search puzzle with observability concepts like metrics, tracing, and alerts for a chance to win a Kubernetes certification voucher.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
            ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
        },
    }
}

export default PuzzleGame;